var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.474 10.0272L17.4728 10.026C16.7968 9.3512 15.9545 9 15 9C14.0454 9 13.2033 9.35126 12.5279 10.0266C11.852 10.7025 11.5 11.5449 11.5 12.5C11.5 13.4548 11.8519 14.297 12.5279 14.9721C13.203 15.6481 14.0452 16 15 16C15.9551 16 16.7975 15.648 17.4734 14.9721C18.1487 14.2967 18.5 13.4546 18.5 12.5C18.5 11.5455 18.1488 10.7032 17.474 10.0272ZM8.31334 18.986L8.31313 18.9857C6.72346 16.6372 6 14.566 6 12.75C6 9.86047 6.91876 7.65347 8.69414 6.01642L8.69429 6.01628C10.5264 4.32617 12.6146 3.5 15 3.5C17.3854 3.5 19.4736 4.32617 21.3057 6.01628L21.3059 6.01642C23.0812 7.65347 24 9.86047 24 12.75C24 14.5661 23.2769 16.6374 21.688 18.9858C20.2056 21.1767 17.9864 23.5753 15 26.1802C12.0137 23.5754 9.79498 21.1768 8.31334 18.986Z",
    stroke: "#455079",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9de80f246adf9219420828e5a20274fb.svg";
export { ForwardRef as ReactComponent };